var BookmarkThumbnail = require("app/ui/thumbnails/BookmarkThumbnail"),
    get               = require("object-path").get,
    kind              = require("enyo/kind");

module.exports = kind(/** @lends  app.ui.thumbnails.BookmarkPlaylistThumbnail.prototype */ {

    /**
     * @private
     */
    name: "app.ui.thumbnails.BookmarkPlaylistThumbnail",

    /**
     * @private
     */
    kind: BookmarkThumbnail,

    /**
     * @private
     */
    classes: "app-ui-thumbnails-bookmark-playlist-thumbnail",

    /**
     * Update the component in response to state changes.
     *
     * @public
     */
    update: kind.inherit(function(sup) {
        return function() {
            var i18nService   = this.app.$.i18nService,
                data          = this.data || {},
                mode          = this.get("mode"),
                title         = get(data, "media_item.meta.title", null) || "",
                $imageWrapper = this.$.imageWrapper;

            if (mode === "link") {
                $imageWrapper.set("href", get(data, "media_item.links.self", null));
                $imageWrapper.setAttribute("title", i18nService.getString("app.ui.thumbnails.BookmarkPlaylistThumbnail.infoLink.tooltip", {
                    playlistName: title
                }));
            }

            this.$.playIcon.set("icon", null);

            this.$.deleteIconWrapper.setAttribute("title", i18nService.getString("app.ui.thumbnails.BookmarkPlaylistThumbnail.deleteBookmarkIcon.tooltip"));

            this.$.progressBarProgress.hide();

            this.$.infoLink.setAttribute("title", i18nService.getString("app.ui.thumbnails.BookmarkPlaylistThumbnail.infoLink.tooltip", {
                playlistName: title
            }));

            sup.apply(this, arguments);
        };
    })

});
